module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    staticClass: "elevation-1"
  }, [_c('div', {
    staticClass: "d-flex"
  }, [_c('div', {
    staticClass: "flex-1"
  }, [_c('v-card-title', {
    staticClass: "pa-2 pl-4 font-size-16"
  }, [_c('span', {
    staticClass: "font-weight-700"
  }, [_vm._v("Total de tickets de")]), _c('span', {
    staticClass: "font-weight-700 primary--text"
  }, [_vm._v("  " + _vm._s(_vm.tipo) + " ")]), _c('span', {
    staticClass: "font-weight-700"
  }, [_vm._v(" del año")]), _c('span', {
    staticClass: "font-weight-700 primary--text"
  }, [_vm._v("  " + _vm._s(_vm.year) + " ")])]), _c('v-card-subtitle', {
    staticClass: "pb-3 font-size-12 grey--text"
  }, [_vm._v("Listado general de todos los ticketsregistrados en el año")])], 1), _c('v-btn', {
    staticClass: "ma-2",
    attrs: {
      "color": "info",
      "small": "small"
    },
    on: {
      "click": function($event) {
        return _vm.fetchTicketsPorAnio()
      }
    }
  }, [_c('v-icon', [_vm._v("sync")]), _vm._v("Actualizar")], 1)], 1), _c('div', {
    staticClass: "d-flex fd-column"
  }, [_c('div', {
    staticClass: "d-flex ml-3 mb-2"
  }, [_c('div', {
    staticClass: "d-flex mx-2"
  }, [_c('v-select', {
    attrs: {
      "solo": "solo",
      "items": _vm.years,
      "disabled": _vm.isLoading,
      "label": "Periodo",
      "dense": "dense",
      "hide-details": "hide-details"
    },
    on: {
      "change": function($event) {
        return _vm.fetchTicketsPorAnio()
      }
    },
    model: {
      value: (_vm.year),
      callback: function($$v) {
        _vm.year = $$v
      },
      expression: "year"
    }
  })], 1), (_vm.tipo === 'garantia') ? _c('div', {
    staticClass: "d-flex mx-2"
  }, [_c('v-select', {
    attrs: {
      "solo": "solo",
      "items": ['taller', 'campo', 'sin asignacion'],
      "disabled": _vm.isLoading,
      "label": "Area",
      "dense": "dense",
      "hide-details": "hide-details"
    },
    on: {
      "change": function($event) {
        return _vm.fetchTicketsPorAnio()
      }
    },
    model: {
      value: (_vm.tipoArea),
      callback: function($$v) {
        _vm.tipoArea = $$v
      },
      expression: "tipoArea"
    }
  })], 1) : _vm._e()]), _c('v-data-table', {
    attrs: {
      "headers": _vm.headers,
      "dense": "dense",
      "item-key": "codigo",
      "items": _vm.lista,
      "hide-default-footer": "hide-default-footer",
      "loading": _vm.isLoading,
      "disable-pagination": "disable-pagination"
    }
  }), (_vm.renderChart) ? _c('Pie-Chart', {
    ref: "lineChart",
    attrs: {
      "pendientes": _vm.valuesPendientes,
      "resueltos": _vm.valuesResueltos
    }
  }) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-251e0ef8","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/c_card_chart_pie_cantidad_total_tickets_por_meses.vue
// module id = 484
// module chunks = 1